/** * @author Bhavani Naralasetty * @email Bhavani.Naralaseetty@ul.com * @create date 2020-09-04
11:46:51 * @modify date 2020-09-04 11:46:51 * @desc resourceslist view page */
<template>
  <div class="resources-list" id="list-grid" v-if="Object.keys(dataList).length">
    <div class="mt-25 pr-10 pl-10" v-if="Object.keys(dataList.resources).length">
      <div class="heading">Free Resources ({{ Object.keys(dataList.resources).length }})</div>
    </div>
    <div v-for="(value, index) in dataList.resources" :key="index">
      <div class="row">
        <div class="card-spacing">
          <div
            class="list-sub-widget"
            :class="{ 'list-sub-widget-last-item': index === dataList.resources.length - 1 }"
          >
            <div class="row m-0">
              <div class="sub-widget-content d-flex align-items-center">
                <div class="bg-image">
                  <img :src="blobLocResource + value.image_location + '?' + sasTokenResources" />
                </div>
                <div class="title-desc-wrapper width-100">
                  <div class="row m-0 d-flex sub-widget-content">
                    <div class="desc-container">
                      <div class="">
                        <router-link
                          :to="{
                            name: value.route_name,
                            params: { filterCountry: validateEUCountrie(country) }
                          }"
                        >
                          <div class="title-desc-name">{{ value.name }}</div>
                        </router-link>
                      </div>
                      <div class="">
                        <div class="title-desc-text">
                          {{ value.description }}
                        </div>
                      </div>
                    </div>
                    <div class="chevron-rt">
                      <router-link
                        class="tools-text redirect-link sub_heading pr-0"
                        :to="{
                          name: value.route_name,
                          params: { filterCountry: validateEUCountrie(country) }
                        }"
                      >
                        See More
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="brdr-btm" v-if="Object.keys(dataList.resources).length"></div>
    <div class="mb-10">
      <div class="row ml-0 mr-0 mt-40 pl-10 pr-10" v-if="Object.keys(dataList.services).length">
        <div class="">
          <div class="heading">Premium Services ({{ Object.keys(dataList.services).length }})</div>
        </div>
      </div>
      <div v-for="(value, index) in dataList.services" :key="index">
        <div class="row">
          <div class="card-spacing">
            <div
              class="list-sub-widget"
              :class="{ 'list-sub-widget-last-item': index === dataList.services.length - 1 }"
            >
              <div class="row m-0">
                <div class="d-flex align-items-center sub-widget-content">
                  <div class="cursor-pointer title-icon-wrapper">
                    <img
                      :src="blobLocService + value.image_location + '?' + sasTokenServices"
                      alt="resources-icon"
                    />
                  </div>
                  <div class="cursor-pointer title-desc-wrapper width-100">
                    <div class="row m-0 d-flex sub-widget-content">
                      <div class="desc-container width-100 services-desc">
                        <div class="">
                          <router-link
                            :to="{
                              name: servicesUrl[value.id].route_name,
                              params: { filterCountry: validateEUCountrie(country) }
                            }"
                          >
                            <div class="title-desc-name pt-0">{{ value.name }}</div>
                          </router-link>
                        </div>
                        <div class="width-100">
                          <div class="title-desc-text desc-services-text pt-0">
                            {{ value.description }}
                            <!-- <list-description :description="value.description"></list-description> -->
                          </div>
                        </div>
                      </div>
                      <div class="chevron-rt">
                        <router-link
                          class="tools-text redirect-link serv-redirect-link sub_heading"
                          :to="{
                            name: servicesUrl[value.id].route_name,
                            params: { filterCountry: validateEUCountrie(country) }
                          }"
                        >
                          <!-- <img
                            src="/static/images/icons/chevron_right.svg"
                            alt="chevronright-icon"
                          /> -->
                          See More
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSasToken } from '../../apis/regsAndGuidance';
import ListDescription from './ListDescription.vue';

export default {
  props: ['dataList', 'country', 'EUCountries'],
  components: {
    ListDescription
  },
  data() {
    return {
      sasTokenServices: '',
      sasTokenResources: '',
      blobLocService: '',
      blobLocResource: '',
      servicesUrl: {
        1: { url: '/layout/trackplusdashboard', route_name: 'TrackplusDashboard' },
        2: { url: '/layout/regulatoryprocesscharts', route_name: 'RegulatoryProcessCharts' },
        3: { url: '/layout/submission-builder', route_name: 'SubmissionBuilder' },
        4: { url: '/layout/regulatory-updates', route_name: 'RegulatoryUpdates' },
        5: { url: '/layout/market-place/service/5', route_name: null },
        6: { url: '/layout/prodclassification', route_name: 'ProdClassification' },
        7: { url: '/layout/regulatory-pathway', route_name: 'RegulatoryPathway' },
        8: { url: '/layout/market-place/service/8', route_name: null },
        9: { url: '/layout/market-place/service/9', route_name: null },
        10: { url: '/layout/market-place/service/10', route_name: null }
      }
    };
  },
  async created() {
    await this.getSasTokenForResouces();
    await this.getSasTokenForServices();
    this.blobLocService = process.env.VUE_APP_AZURE_BLOB_URL;
    this.blobLocResource = process.env.VUE_APP_AZURE_BLOB_URL;
  },
  methods: {
    validateEUCountrie(country) {
      const indexVal = this.EUCountries.indexOf(country);
      return indexVal !== -1 ? 'European Union' : country;
    },
    async getSasTokenForResouces() {
      const formData = {
        container_name: 'dashboard-resources',
        file_name: '',
        folder_name: '',
        permissions: 'read',
        storage_name: 'rams-storage-java'
      };
      const token = await getSasToken(formData);
      if (token.message === 'success') {
        this.sasTokenResources = token.data;
      }
    },
    async getSasTokenForServices() {
      const formData = {
        container_name: 'market-place',
        file_name: '',
        folder_name: '',
        permissions: 'read',
        storage_name: 'rams-storage-java'
      };
      const token = await getSasToken(formData);
      if (token.message === 'success') {
        this.sasTokenServices = token.data;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.resources-list {
  font-family: $font-family-roboto;
  .heading {
    font-family: $font-family-roboto;
    font-style: normal;
    font-weight: $font-weight-400;
    font-size: $font-20;
    line-height: 23px;
    color: $dark-black-alpha;
  }

  .card-spacing {
    padding-left: 40px;
    padding-right: 40px;
    .list-sub-widget {
      background: $deep-white;
      padding-bottom: 15px;
      border-bottom: 0.5px solid #d3d6d9;
      padding-top: 15px;
      &.list-sub-widget-last-item {
        border-bottom: none;
      }
      .title-icon-wrapper {
        background-color: $deep-white;
        padding: 0px;
        border-radius: $radius10 $radius0 $radius0 $radius10;
        text-align: center;
        > img {
          border-radius: $radius10;
          width: 98px;
          height: 84px;
        }
      }
      .bg-image {
        align-self: flex-start;
        margin-top: 13px;
        img {
          width: 98px;
          height: 94px;
          border-radius: $radius10;
          object-fit: cover;
        }
      }
      .title-desc-wrapper {
        background-color: $deep-white;
        font-size: $font-14;
        min-height: 104px;
        border-radius: $radius0 $radius10 $radius10 $radius0;
        padding-top: 10px;
        padding-bottom: 12px;
        .desc-container {
          padding-right: 30px;
          padding-left: 24px;
          &.services-desc {
            // padding-left: 16px;
          }
          .title-desc-name {
            font-size: $font-18;
            font-weight: $font-weight-400;
            color: $primary;
            line-height: 21px;
            padding: 8px 0px;
            padding-top: 0;
          }
          .title-desc-text {
            font-family: $font-family-roboto;
            font-style: normal;
            font-weight: $font-weight-400;
            font-size: $font-16;
            line-height: 19px;
            color: $dark-black-alpha;
            &.desc-services-text {
              max-width: 453px;
            }
          }
        }
        .chevron-rt {
          text-align: right;
          display: flex;
          align-items: flex-end;
          .redirect-link {
            width: max-content;
            &.sub_heading {
              font-family: $font-family-roboto;
              font-style: normal;
              font-weight: $font-weight-medium;
              font-size: $font-16;
              line-height: 19px;
              text-align: right;
              color: $messenger-blue;
              padding-right: 16px;
            }
          }
        }
      }
    }
  }
  .brdr-btm {
    // padding-bottom: 30px;
    border-bottom: 0.5px solid $deep-gray;
    margin-left: 9px;
    margin-right: 9px;
  }
  .width-100 {
    width: 100%;
  }
  .mt-40 {
    margin-top: 40px;
  }
}

@media (max-width: 767px) {
  .resources-list {
    .card-spacing {
      padding-top: 9px;
      .list-sub-widget {
        border-bottom: none;
        .sub-widget-content {
          flex-direction: column;
        }
        .title-icon-wrapper {
          > img {
            width: 263px;
            height: 207px;
            border-radius: 19px;
            margin-bottom: 24px;
          }
        }
        .background-img {
          width: 263px;
          height: 207px;
          border-radius: 19px;
          margin-bottom: 24px;
          align-self: unset;
          margin-top: unset;
        }
        .bg-image {
          align-self: unset;
          margin-top: unset;
          img {
            width: 263px;
            height: 207px;
            border-radius: 19px;
            margin-bottom: 24px;
          }
        }
        .title-desc-wrapper {
          font-size: $font-12;
          padding-top: 3px;
          padding-bottom: 3px;
          width: 264px;
          .desc-container {
            padding: 0;
            &.services-desc {
              padding-left: 0px;
            }
            .title-desc-name {
              padding: 5px 0px;
            }
            .title-desc-text {
              text-align: justify;
            }
          }
          .chevron-rt {
            padding-left: 0px;
            justify-content: flex-end;
            margin-top: 16px;
          }
        }
      }
    }
  }
}
</style>
